import { Center, Splitter } from "@chakra-ui/react"

const SplitterComponent = (props: any) => {

    const children: any[] = props.children

    return (
        <Splitter.Root
        panels={[{ id: "a" }, { id: "b" }]}
        borderWidth="1px"
        >
        <Splitter.Panel id="a">
            <Center boxSize="full" textStyle="2xl">
            {children[0]}
            </Center>
        </Splitter.Panel>
        <Splitter.ResizeTrigger id="a:b" />
        <Splitter.Panel id="b">
            <Center boxSize="full" textStyle="2xl">
            {children.length > 0 ? children[1] : "No Content"}
            </Center>
        </Splitter.Panel>
        </Splitter.Root>
    )
    
}

export default SplitterComponent